<template>
  <el-main
    class="login-container"
    v-loading.body="isSubmitting"
    :element-loading-text="$t('Submitting...')">
    <el-row class="login-page" type="flex" justify="center" align="middle">
      <el-col :span="12" class="splash-holder">
        <div class="splash">
          <!--<img src="@/assets/images/logo_scb-wh.png" alt="SCB Payin Slip" class="logo">-->
          <h1 class="title">BP Payin Slip</h1>
          <h2 class="subtitle">{{ appName | translate }}</h2>
        </div>
        <div class="footer">
        </div>
      </el-col>
      <el-col :span="12">
        <el-row type="flex" justify="left" align="middle">
          <el-col :span="12" :offset="3" class="form-holder">
            <div class="login-form-holder">
              <h2>เข้าสู่ระบบ</h2>
              <el-form
                :model="loginModel"
                :rules="loginRules"
                ref="loginModel"
                label-width="120px"
                class="login-form"
                label-position="top"
                @submit.native.prevent="submitForm('loginModel')">
                <el-form-item :label="$t('E-mail')" prop="email">
                  <el-input
                    v-model="loginModel.email"
                    id="loginModel-email"
                    placeholder="กรอกอีเมลของท่าน"
                    :autofocus="true"
                    suffix-icon="el-icon-message"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Password')" prop="password">
                  <el-input
                    v-model="loginModel.password"
                    id="loginModel-password"
                    placeholder="กรอกรหัสผ่านของท่าน"
                    type="password"
                    suffix-icon="el-icon-star-off"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" id="loginModel-loginButton" native-type="submit">{{ 'Login' | translate }}</el-button>
                  <p>
                    {{ $t('Forgot your password?') }} <el-button type="text" class="forgot-password-btn" @click.prevent="goToForgotPassword">{{ $t('Recover Password now!') }}</el-button>
                  </p>
                  <p v-if="tenantId === 'scb'">
                    <a href="/static/bppayin-admin-user-manual-v2.1.pdf" target="_blank">ดาวน์โหลดคู่มือการใช้งาน</a>
                  </p>
                  <p v-else>
                    <a href="/static/bppayin-biller-user-manual-v2.3.pdf" target="_blank">ดาวน์โหลดคู่มือการใช้งาน</a>
                  </p>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <div v-if="showNotice" class="notice-overlay" @click.self="closeNotice">
      <div class="notice-content" @click.self="closeNotice">
        <img src="@/assets/images/notice_system_migrate.jpg" alt="ประกาศ" class="notice-image">
        <el-button type="primary" class="notice-button" @click="closeNotice">เข้าสู่เว็บไซต์</el-button>
      </div>
    </div>
  </el-main>
</template>

<script>
/**
 * Login view
 */
const LoginView = {
  name: 'login',
  data() {
    return {
      isSubmitting: false,
      showNotice: true,
      submitError: '',
      loginModel: {
        email: '',
        password: '',
      },
      loginRules: {
        email: [
          { required: true, message: this.$t('Please input a valid email address'), trigger: 'blur' },
          { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('Please input password'), trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.idToken;
    },
    currentYear() {
      const now = new Date();
      return now.getFullYear();
    },
    appName() {
      return this.$store.getters.appName;
    },
    tenantId() {
      return this.$store.getters.tenantId;
    },
  },
  methods: {
    closeNotice() {
      this.showNotice = false;
    },
    addErrorMessage() {
      this.$store.dispatch('ADD_ERROR_FLASH', 'error message');
    },
    validateForm(valid) {
      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      const payload = JSON.parse(JSON.stringify(this.loginModel));
      payload.tenant_id = this.$store.getters.tenantId;
      this.$store.dispatch('LOGIN', payload).then(() => {
        this.isSubmitting = false;
      }).catch((msg) => {
        this.isSubmitting = false;
        if (msg) {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t(msg));
        } else {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t('Unexpected error'));
        }
      });
      return true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    goToForgotPassword() {
      this.$router.push({ name: 'ForgotPassword' });
    },
  },
};
export default LoginView;
</script>

<style lang="scss" scoped>
@import '../../assets/styles/pages/auth-page';

.notice-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background-color: rgba(0, 0, 0, 0.7);
}

.notice-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1920px;
  max-height: 100%;
}

.notice-image {
  display: block;
  max-width: 100%;
  max-height: calc(100vh - 120px);
  object-fit: contain;
}

.notice-button {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/login.vue